import qs from 'qs';
import interceptors from '@/api/interceptors';
import { client } from './client';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, password) {
    return client.post('auth/login', qs.stringify({ platform: 'warehouse', username, password }), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

export default {
    login,
};
